import templateUrl from 'emun.salesrep/customers-pastdue.htm';
import AutoQuery from 'servicestack/auto-query/auto-query';
import basicController from 'servicestack/basic.controller.properties';
import resolve from 'ioc/resolve';
import activityConfig from "emun.activity/activity.config";

class CustomersPastDueController {
	constructor($rootScope) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.activityConfig = activityConfig;

		var context = $ctrl.context || 'rep';
		var repFilter = "";
		if (context != 'executive') {
			var filterType = "SalesRepID";
			if (context == 'manager') {
				filterType = 'ManagerId';
			}
			repFilter = "&" + filterType + "=" + $ctrl.rep.id;
		}


		//var filter = "SalesRepID";
		//if (context == 'manager') { filter = "ManagerId";}

		$ctrl.query = new AutoQuery({
			url: 'QueryRetailersJoin.json?Include=Total&Past30DaysGreaterThan=0' + repFilter,
			orderBy: 'CompanyName',
			autoLoad: true,
			pageSize: 10,
			scrollTop: false
		});
	}
}

let CustomersPastDue = {
	bindings: {
		repId: '@',
		context: '@',
		rep: '<'
	},
	controller: CustomersPastDueController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
}

export default CustomersPastDue;